import { Section, SectionSubTitle, Typography } from 'common/components';
import React from 'react';
import { bathroomCollectionsHeaderTitle } from './bathroom-collections-header-styles';

export const BathroomCollectionsHeader: React.FC = () => (
  <Section>
    <SectionSubTitle className={bathroomCollectionsHeaderTitle} as="h1" margin="s">
      Наборы мебели для ванной комнаты
    </SectionSubTitle>
    <Typography adaptive={false} variant="m" size="body_long">
      Обновите ванную комнату с&nbsp;готовыми наборами мебели
    </Typography>
  </Section>
);
